import { useMemo } from 'react';

import { useAtomValue } from 'jotai';

import { ParameterNode } from '@data';
import { useLayoutCustomizations, useUiParameters } from '@queries';
import { activityAtom } from '@store';

const KEY_PARAMETER_FALLBACK: ParameterNode = {
    categories: {
        metric: 'metric.linear_displacement_from_p1',
        swingFoundationGroup: 'swing_foundation_group.p7_sway',
    },
    id: 'parameter.pelvis_sway_p7',

    metadata: {},

    i18n: 'parameter.pelvis_sway_p7',

    parameter: {
        smpId: -1,
        name: 'pelvis_sway_p7',
        unit: 'm',
        position: 'p7',
        axis: 'y',
        timeSeriesId: 'pelvis_linear_displacement',
        supportedLive: false,
    },

    showOn: ['kiosk', 'floor'],

    type: 'parameter',
};

export const useKeyParameter = () => {
    const { data: parameters, isLoading: isParametersLoading } = useUiParameters();
    const activityId = useAtomValue(activityAtom);
    const {
        data: customizations,
        isLoading: isCustomizationsLoading,
        isRefetching,
    } = useLayoutCustomizations(activityId?.layoutId || -1);

    const customization = useMemo(
        () => customizations?.find((c) => c.parentUiNodeId === 'activity_navigation.default'),
        [customizations],
    );
    const keyParameterNode = useMemo(() => {
        return parameters?.find((node) => node.id === customization?.childUiNodeId, []);
    }, [customization?.childUiNodeId, parameters]);

    return [
        keyParameterNode || KEY_PARAMETER_FALLBACK,
        isParametersLoading || isCustomizationsLoading,
        isRefetching,
    ] as const;
};
